import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UsersIcon, SearchIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
const services = [{
  icon: UsersIcon,
  title: 'Gestión integral',
  description: 'Desde la definición del perfil hasta la incorporación del candidato.',
  color: 'from-emerald-50 to-teal-50'
}, {
  icon: SearchIcon,
  title: 'Cobertura nacional y selección de múltiples posiciones',
  description: 'Operativas, mandos medios y gerenciales.',
  color: 'from-blue-50 to-cyan-50'
}, {
  icon: ShieldCheckIcon,
  title: 'Selección personalizada y confidencial',
  description: 'Garantizamos procesos adaptados a la cultura organizacional y a los objetivos estratégicos de cada empresa.',
  color: 'from-purple-50 to-pink-50'
}, {
  icon: TrendingUpIcon,
  title: 'Acompañamiento en la incorporación',
  description: 'Proveemos una integración cuidada, fluida y sostenible en el tiempo.',
  color: 'from-amber-50 to-orange-50'
}];
export function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="servicios" ref={ref} className="py-32 px-6 bg-white scroll-mt-20" data-id="element-161">
      <div className="max-w-7xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-163">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-164">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-slate-700 font-semibold mb-6" data-id="element-165">
            La búsqueda que hace la diferencia
          </p>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-166">
            Sabemos que encontrar a la persona indicada no siempre es fácil. Por
            eso, en Enlaces Consultora acompañamos a las empresas en crecimiento
            para construir equipos sólidos, con procesos ágiles, confiables y
            comprometidos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-167">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className={`p-8 bg-gradient-to-br ${service.color} rounded-xl border border-slate-100`} data-id="element-168">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-4 shadow-sm" data-id="element-169">
                <service.icon className="w-7 h-7 text-emerald-600" data-id="element-170" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-171">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-172">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}